import { Moon, Plus, Sun } from "lucide-react";
import { cn } from "@/lib/utils";

interface TopbarActionsProps {
  theme?: string;
  onThemeToggle: () => void;
  onNewReservation: () => void;
}

export function TopbarActions({
  theme,
  onThemeToggle,
  onNewReservation,
}: TopbarActionsProps) {
  return (
    <>
      <button
        onClick={onThemeToggle}
        className="hidden w-11 h-11 md:flex items-center justify-center rounded-xl hover:bg-muted/50 transition-all duration-180 ease-[cubic-bezier(0.16,1,0.3,1)] shrink-0"
        title={theme === "dark" ? "Modo claro" : "Modo escuro"}
        aria-label={
          theme === "dark"
            ? "Alternar para modo claro"
            : "Alternar para modo escuro"
        }
      >
        {theme === "dark" ? (
          <Sun className="w-5 h-5 text-amber-400" />
        ) : (
          <Moon className="w-5 h-5 text-blue-400" />
        )}
      </button>

      <button
        type="button"
        onClick={onNewReservation}
        aria-label="Nova reserva"
        className={cn(
          "flex items-center gap-2 px-3 md:px-4 h-11 rounded-xl shrink-0",
          "bg-primary dark:bg-linear-to-r dark:from-primary dark:to-secondary",
          "text-white font-medium text-sm",
          "hover:opacity-90 hover:shadow-lg hover:shadow-primary/25",
          "transition-all duration-180 ease-[cubic-bezier(0.16,1,0.3,1)]",
          "glow-primary",
        )}
      >
        <Plus className="w-4 h-4" />
        <span className="hidden sm:inline">Nova Reserva</span>
      </button>
    </>
  );
}
